import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'classroom_professors',
  label: 'Professores da turma',
  actions: ['list', 'create', 'edit', 'delete'],
  onlyPermission: true,
  parentName: 'classroom_management'
};

export default generateResources(resource);
